import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import DraftUpdateModal from '../DraftUpdateModal';
const ADD_SERVICES_LOADER = 'addServicesLoader';
export const draftUpdateModal = (param)=>{
    let { draft, options, changeDraftInRow } = param;
    return {
        biName: 'draft_update_modal',
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(DraftUpdateModal, _object_spread_props(_object_spread({}, options), {
                draft: draft,
                dismissModal: dismissModal,
                changeDraftInRow: changeDraftInRow
            }));
        }
    };
};
export const saveDraftWithLoader = (param)=>{
    let { newDraft, deps } = param;
    return {
        newDraft,
        onSuccess: ()=>deps.updateDraft(newDraft),
        onStartLoader: ()=>deps.startLoader(ADD_SERVICES_LOADER),
        onStopLoader: ()=>deps.stopLoader(ADD_SERVICES_LOADER)
    };
};
